import { render, staticRenderFns } from "./DiscountApplicators.vue?vue&type=template&id=c56033b2&scoped=true"
import script from "./DiscountApplicators.vue?vue&type=script&lang=js"
export * from "./DiscountApplicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56033b2",
  null
  
)

export default component.exports